import { render, staticRenderFns } from "./PosterDemands.vue?vue&type=template&id=93a94fb4"
import script from "./PosterDemands.vue?vue&type=script&lang=js"
export * from "./PosterDemands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports